import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { omit, last } from "lodash-es";
import { Inject, Component, Vue } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { getLayoutSlot } from "../../../../lib/utils";
const makeEmptyRows = count => Array.from({
  length: count
}, () => ({
  type: 'w-col',
  children: [],
  props: {}
}));
let ColConfigPanel = class ColConfigPanel extends Vue {
  constructor() {
    super(...arguments);
    this.colConfig = '';
  }
  get compPath() {
    return this.designer.compPath;
  }
  get comp() {
    return this.designer.activeComp;
  }
  mounted() {
    this.$watch(() => [this.comp], this.refreshCol, {
      immediate: true,
      deep: true
    });
  }
  refreshCol() {
    const defaultWeight = this.uc.components['w-col'].defaultProps.weight;
    const columns = getLayoutSlot(this.comp, 'default', false) || [];
    this.colConfig = columns.map(item => {
      var _item$props, _item$props2;
      return ((_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.width) || ((_item$props2 = item.props) === null || _item$props2 === void 0 ? void 0 : _item$props2.weight) || defaultWeight;
    }).map(item => {
      if (item.$expr) {
        return `"${item.$expr}"`;
      }
      return item;
    }).join(' : ');
  }
  changeCol(value) {
    const colConfigs = value.split(':').map(item => item.trim());
    const columns = getLayoutSlot(this.comp, 'default', false) || [];
    // 对于少填入的比例 进行删除列
    if (colConfigs.length < columns.length) {
      const deleted = columns.splice(colConfigs.length, columns.length - colConfigs.length);
      // TODO: deleted里的全都塞最后一个col里 有必要吗?
      const childrenContents = deleted.map(item => getLayoutSlot(item, 'default', false)).filter(Boolean).flat();
      const lastCol = last(columns);
      if (lastCol) {
        this.$set(lastCol, 'children', [...(lastCol.children || []), ...childrenContents]);
      }
    }
    // 对于多填入的比例 进行添加列
    if (colConfigs.length > columns.length) {
      // 这里work了 就先不$set了
      columns.push(...makeEmptyRows(colConfigs.length - columns.length));
    }
    columns.forEach((comp, index) => {
      const config = colConfigs[index];
      const props = {};
      if (/^\d+(\.\d+)?$/.test(config)) {
        const weight = parseFloat(config);
        props.weight = weight;
      } else if (config.startsWith('"') && config.endsWith('"')) {
        var _comp$props;
        const key = (_comp$props = comp.props) !== null && _comp$props !== void 0 && _comp$props.width ? 'width' : 'weight';
        props[key] = {
          $expr: config.substring(1, config.length - 1)
        };
      } else {
        props.width = config;
      }
      this.designer.modifyComp(`${this.compPath}/default/${index}`, comp => {
        const prop = {
          ...omit(comp.props, ['weight', 'width']),
          ...props
        };
        this.$set(comp, 'props', prop);
      });
    });
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "style": "flex-grow:1"
    }, [h("a-input", _mergeJSXProps([{
      "attrs": {
        "value": this.colConfig
      }
    }, {
      "on": {
        'change.value': this.changeCol
      }
    }]))]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], ColConfigPanel.prototype, "designer", void 0);
__decorate([Inject({
  from: INJECT_UICORE_BUS
})], ColConfigPanel.prototype, "uc", void 0);
ColConfigPanel = __decorate([Component({
  name: 'ColConfigPanel'
})], ColConfigPanel);
export { ColConfigPanel };